/**
 * Convert string into crammed case.
 * Join string into one.
 * @memberof module:stringcase/lib
 * @function cramcase
 * @param {string} str - String to convert.
 * @returns {string} Enum cased string.
 */
'use strict';

var snakecase = require('./snakecase');
/** @lends cramcase */


function cramcase(str) {
  return snakecase(str).replace(/_/g, '');
}

module.exports = cramcase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNyYW1jYXNlLmpzIl0sIm5hbWVzIjpbInNuYWtlY2FzZSIsInJlcXVpcmUiLCJjcmFtY2FzZSIsInN0ciIsInJlcGxhY2UiLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7QUFTQTs7QUFFQSxJQUFNQSxTQUFTLEdBQUdDLE9BQU8sQ0FBQyxhQUFELENBQXpCO0FBRUE7OztBQUNBLFNBQVNDLFFBQVQsQ0FBbUJDLEdBQW5CLEVBQXdCO0FBQ3RCLFNBQU9ILFNBQVMsQ0FBQ0csR0FBRCxDQUFULENBQWVDLE9BQWYsQ0FBdUIsSUFBdkIsRUFBNkIsRUFBN0IsQ0FBUDtBQUNEOztBQUVEQyxNQUFNLENBQUNDLE9BQVAsR0FBaUJKLFFBQWpCIiwic291cmNlUm9vdCI6Ii4uLy4uL2xpYiIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29udmVydCBzdHJpbmcgaW50byBjcmFtbWVkIGNhc2UuXG4gKiBKb2luIHN0cmluZyBpbnRvIG9uZS5cbiAqIEBtZW1iZXJvZiBtb2R1bGU6c3RyaW5nY2FzZS9saWJcbiAqIEBmdW5jdGlvbiBjcmFtY2FzZVxuICogQHBhcmFtIHtzdHJpbmd9IHN0ciAtIFN0cmluZyB0byBjb252ZXJ0LlxuICogQHJldHVybnMge3N0cmluZ30gRW51bSBjYXNlZCBzdHJpbmcuXG4gKi9cblxuJ3VzZSBzdHJpY3QnXG5cbmNvbnN0IHNuYWtlY2FzZSA9IHJlcXVpcmUoJy4vc25ha2VjYXNlJylcblxuLyoqIEBsZW5kcyBjcmFtY2FzZSAqL1xuZnVuY3Rpb24gY3JhbWNhc2UgKHN0cikge1xuICByZXR1cm4gc25ha2VjYXNlKHN0cikucmVwbGFjZSgvXy9nLCAnJylcbn1cblxubW9kdWxlLmV4cG9ydHMgPSBjcmFtY2FzZVxuIl19